<template>
  <div class="container">
    <PreviewDeck :info="deck" />
  </div>
</template>

<script>
import cookies from 'js-cookie';
import PreviewDeck from '@itbpbg/lms-components/src/Flashcards/PreviewDeck.vue';
import global from '@itbpbg/lms-components/src/mixins/global';

export default {
  components: {
    PreviewDeck,
  },
  mixins: [global],

  async asyncData({
    $axios, route, error, store, $config, $globalHelper, req,
  }) {
    const deck = await $axios.$get(`/flashcards/${route.params.slug}${route.query.review ? '?review=1' : '?initial_data=1'}`).catch(() => false);
    if (!deck) {
      return error({ statusCode: 404, message: 'Page not found' });
    }
    if (!store.state.auth.user) {
      let review;
      if (process.server) {
        const parsedCookies = $globalHelper.parseCookies(req.headers.cookie);
        review = parsedCookies.review_cards;
      } else {
        review = cookies.get('review_cards');
      }

      let reviewed = 0;
      if (review) {
        const data = JSON.parse(review);
        if (data[deck.id]) {
          reviewed = data[deck.id];
        }
      }
      if (reviewed) {
        for (let i = 0; i < deck.cards.length; i += 1) {
          if (i < reviewed) {
            deck.cards[i].status = 'reviewed';
          } else {
            deck.cards[i].status = 'not-reviewed';
          }
        }
      }
    }

    deck.fullPath = `${$config.siteUrl}${route.fullPath}`;
    deck.created = deck.created || new Date();
    deck.updated = deck.updated || new Date();

    return { deck };
  },
  head() {
    const metaTitle = `${this.deck.metatitle}`;
    const metaDescription = this.deck.metadescription;

    return {
      titleTemplate: `${metaTitle}%s`,
      link: [
        { rel: 'canonical', href: this.canonicalURL() },
      ],
      script: [
        { src: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.7/MathJax.js?config=TeX-MML-AM_CHTML', async: true },
      ],
      meta: this.metaProps({
        ...this.deck,
        metaTitle,
        metaDescription,
      }),
    };
  },
};
</script>
